import { css } from '@emotion/react';

export const buttonsStyle = css({
  marginLeft: '10px',
  marginRight: '10px',
});
